import { getDeviceConfig } from '@/device/deviceConfig'
import { performanceProfile } from '@/device/performanceProfile'
import { setClassToken } from '@amazon/vinyl-tsx'
import { reduceMotion$, setReduceMotionDefault } from '@/util/reducedMotion'
import { isLegacyEngine, LEGACY_ENGINE_CLASS } from '@/device/legacyEngine'

export function initializeDeviceStyling() {
    const { deviceType, performanceTier } = getDeviceConfig()
    const classList = document.documentElement.classList
    classList.add(deviceType, `perf-${performanceTier}`)
    setReduceMotionDefault(performanceProfile(performanceTier).reduceMotionByDefault)
    reduceMotion$.onData((reduced) =>
        setClassToken(document.documentElement, 'reduce-motion', reduced)
    )
    if (isLegacyEngine()) classList.add(LEGACY_ENGINE_CLASS)
}
